import {request_async} from "@/utils/requestAsync";
import {API_URL_ERP} from "@/model/ConfigModel";

// 新增修改
export async function addOrEdit(data) {
  return request_async(API_URL_ERP + "/v1/commonInfo/", "post_body", data);
}
